module.exports = __webpack_public_path__ + "img/Cucumber.4222cf22.svg";